<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer " (click)="goBack()"></i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">
            
            پشتیبانی

          </a>

    </div>

</div>

<main class="container-xxl">

    <section class="border border-2 p-2 mt-4 dirI" style="max-height: 85vh;">

        <form class="w-100 row gx-2 gy-3 gy-md-0 p-2">

            <div class="col-12 col-md-11">

                <input type="text" class="w-100 my-3 form-control" placeholder="جستجو کنید...." (keyup)="filter_list($event.target)">

            </div>

            <div class="col-12 col-md-1 d-flex align-items-center">
    
                <button class="btn w-100 px-3 btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal"> 
                    
                    افزودن
                
                </button>
        
            </div>

        </form>

        <div class="section">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
        
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>
    
                        <th class="text-center"> عملیات </th>
                
                        <th class="text-center"> شماره تیکت </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> زمان </th>
        
                        <th class="text-center"> وضعیت تیکت  </th>
                        
                        <th class="text-center"> موضوع تیکت </th>
        
                    </tr>
                    
                </thead>

                <tbody>

                    <tr *ngFor="let item of Support; let i=index" 

                        [ngClass]="item.tiTiketStatus == 3 ? 'bg-green-dark' : item.tiTiketStatus == 6 ? 'bg-blue-light' :
                        
                        item.tiTiketStatus == 0 ? 'bg-smoke' : item.tiTiketStatus == 1 ? 'bg-green-light' :
                        
                        item.tiTiketStatus == 2 ? 'bg-purpel' : item.tiTiketStatus == 4 ? 'bg-pink' :
                        
                        item.tiTiketStatus == 5 ? 'bg-yellow' :'' "
                    
                        style="vertical-align: middle;">

                        <td class="col-1 text-center"> {{ i + 1 | faNum }} </td>

                        <td class="col-1 text-center"> 

                            <i class="fa fa-eye pointer" data-bs-toggle="modal" data-bs-target="#exampleModal2" (click)="singel(i)"></i>

                        </td>

                        <td class="col-2 text-center"> {{ item.iTiket | faNum }}</td>

                        <td class="col-2 text-center"> {{item.strSaveDate | faNum }}</td>

                        <td class="col-1 text-center"> {{item.strSaveTime | faNum }}</td>

                        <td class="col-2 text-center"> {{ item.strTiketStatus_strComment | faNum }}</td>

                        <td class="col-2 text-center"> {{ item.strTiketSubject_strComment | faNum }}</td>

                    </tr>

                </tbody>

            </table>

        </div>

    </section>

</main>

<!-- فرم افزودن -->

<div class="modal fade rtl " id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel">ثبت تیکت</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body " [formGroup]="sabtModel">

                <div class="col-11 mx-auto mt-2">

                    <select class="form-control" formControlName="tiTiketSubject">

                        <option selected value="">انتخاب موضوع</option>

                        <option *ngFor="let item of ServiceTxt" value="{{item.tiTiketSubject}}">{{item.strComment}}</option>

                    </select>

                </div>

                <div class="col-11 mx-auto mt-3">

                    <textarea class="form-control" placeholder="توضیحات" formControlName="strDetail"></textarea>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">

                    <i class="fa fa-close"></i>
                    
                    بستن
                                    
                </button>

                <button type="button" class="btn btn-success" (click)="sabt()">

                    <i class="fa fa-angle-double-down"></i> 
                    
                    ارسال در خواست
                                    
                </button>

            </div>
            
        </div>
        
    </div>
    
</div>

<!--اقدامات-->

<div class="modal fade rtl " id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel2"> اقدامات </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="col-12 d-flex p-3  flex-wrap" [formGroup]="editModel">

                <div class="col-12">

                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport">
                        
                        <span> شماره تیکت : </span>
                        
                        <span class="txt-navy">{{ singelSupport.iTiket | faNum }}</span>
                    
                    </p>
                    
                </div>

                <div class="col-12">

                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport">
                        
                        <span> وضعیت تیکت : </span>
                        
                        <span class="txt-navy">{{singelSupport.strTiketStatus_strComment}}</span>
                    
                    </p>

                </div>
                
                <div class="col-12">

                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport">
                        
                        <span> موضوع تیکت : </span>
                        
                        <span class="txt-navy">{{singelSupport.strTiketSubject_strComment}}</span>
                    
                    </p>

                </div>
                
                <div class="col-12">

                    <p class="rtl d-flex  mx-3 mt-2" *ngIf="singelSupport">
                        
                        <span> زمان : </span>
                        
                        <span class="txt-navy">{{singelSupport.strSaveDate | faNum }}-{{singelSupport.strSaveTime | faNum }}</span>
                    
                    </p>

                </div>

                <div class="col-12 mx-3 mt-2" *ngIf="singelSupport && singelSupport.tiTiketStatus!=5&&singelSupport.tiTiketStatus!=6">

                    <div class="col-11 d-flex align-items-center ">

                        <span class="w-25"> نوع اقدام : </span>
                        
                        <select class="form-select w-75" formControlName="tiTiketSubject">

                            <option *ngFor="let item of tiketStatus " [value]="item.tiTiketStatus"> {{item.strComment}} </option>

                        </select>

                    </div>

                </div>

                <div class="col-12  mx-3 mt-2" *ngIf="singelSupport">

                    <div class="col-12 flex-column">

                        <span> توضیحات : </span>
                        
                        <span class="txt-navy">{{singelSupport.strDetail}}</span>

                        <!-- <textarea type="text" formControlName="strDetail" 
                        
                            [ngClass]="singelSupport && singelSupport.tiTiketStatus!=5&&singelSupport.tiTiketStatus!=6 &&singelSupport.tiTiketStatus!=2 ? '' : 'disabled'"
                            
                            class="form-control shadow " placeholder="توضیحات ">

                        </textarea> -->

                    </div>

                </div>

                <div class="col-12 mt-3  border border-2">

                    <table class="col-12 table table-striped rounded-3">
        
                        <thead>
                
                            <tr class="">
                
                                <th class="text-center col-1"> # </th>
            
                                <th class="text-center"> تاریخ </th>

                                <th class="text-center"> زمان </th>
                
                                <th class="text-center"> شرح اقدام </th>
                
                            </tr>
                            
                        </thead>
        
                        <tbody>
        
                            <tr *ngFor="let item of Actions; let i=index" style="vertical-align: middle;">
        
                                <td class="col-1 text-center"> {{ i + 1 | faNum }} </td>
        
                                <td class="col-2 text-center"> {{item.strDate | faNum}} </td>

                                <td class="col-2 text-center"> {{item.strTime | faNum}} </td>
        
                                <td class="col-7 text-center"> {{ item.strActionDetail | faNum }}</td>
        
                            </tr>
        
                        </tbody>
        
                    </table>
        
                </div>

            </div>

            <div class="modal-footer">

                <div class="col-12 d-flex justify-content-start" 
                
                    *ngIf="singelSupport && singelSupport.tiTiketStatus!=5 
                    
                    && singelSupport.tiTiketStatus!=6 && singelSupport.tiTiketStatus!=2">

                    <button class="btn btn-primary px-5" (click)="edit()">
                        
                        ویرایش
                        
                    </button>

                </div>

            </div>

        </div>

    </div>

</div>